module.exports = __webpack_public_path__ + "img/crypto_flowers.d8b246fa.png";